import axios from "axios"


export const axiosInstance = axios.create({
    // baseURL: "http://127.0.0.1:5001/clone-c3fe6/us-central1/api"
    baseURL: "https://api-3e4k26wofq-uc.a.run.app/"
})

